import { render, staticRenderFns } from "./Socials.vue?vue&type=template&id=c8295910&scoped=true"
import script from "./Socials.vue?vue&type=script&lang=js"
export * from "./Socials.vue?vue&type=script&lang=js"
import style0 from "./Socials.vue?vue&type=style&index=0&id=c8295910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8295910",
  null
  
)

export default component.exports